import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useAppContext } from 'app/context/app';
import { Availability } from 'app/interfaces/common';
import { checkAvailability } from 'app/services/siteAvailability';
import { constants } from 'app/utils';

/**
 * useAvailable custom hook
 * Checks if GAK round is open for redemption and sets state accordingly
 * @param forceRedirect Flag to determine whether user is redirected to homepage
 */
export default function useAvailable(forceRedirect: boolean = true) {
  const history = useHistory();
  const { actions } = useAppContext();

  useEffect(() => {
    async function checkAvailable() {
      // We can safely check availability of undefined as manual checks will be done on selection
      const { status } = await checkAvailability();
      actions.updateAvailability(status);

      // if forceRedirect flag is false then don't redirect user
      if (!forceRedirect) return;

      if (status !== Availability.Open) {
        history.push(constants.Routes.Home);
      }
    }

    checkAvailable();
  }, [actions, history, forceRedirect]);
}
